import { useEffect, useState } from 'react';
import { downloadPurchaseRequestAttachment } from '../api';

const IMAGE_FILE = /\.(jpe?g|png|gif|webp)(?:[?#].*)?$/i;

// Purchase request files are in a private bucket, so their stored links can't be shown in an <img>.
// Loads the saved image attachments of a request through the authenticated attachment endpoint and
// returns { [attachmentId]: objectUrl } (an attachment is missing until it has loaded, or if it fails).
export default function usePurchaseAttachmentThumbnails(requestId, attachments = []) {
  const [thumbnails, setThumbnails] = useState({});
  const imageIds = (attachments || [])
    .filter((file) => file?._id && IMAGE_FILE.test(file.filename || file.name || file.fileUrl || file.url || ''))
    .map((file) => String(file._id))
    .join(',');

  useEffect(() => {
    setThumbnails({});
    if (!requestId || !imageIds || typeof URL === 'undefined' || typeof URL.createObjectURL !== 'function') {
      return undefined;
    }
    let cancelled = false;
    const urls = [];
    imageIds.split(',').forEach((attachmentId) => {
      downloadPurchaseRequestAttachment(requestId, attachmentId)
        .then((response) => {
          if (cancelled || !(response?.data instanceof Blob)) return;
          const url = URL.createObjectURL(response.data);
          urls.push(url);
          setThumbnails((prev) => ({ ...prev, [attachmentId]: url }));
        })
        .catch(() => {
          // No thumbnail; the file tile is shown instead.
        });
    });
    return () => {
      cancelled = true;
      urls.forEach((url) => URL.revokeObjectURL(url));
    };
  }, [requestId, imageIds]);

  return thumbnails;
}
